import React from "react";
import { useTranslation } from "react-i18next";
import "./index.css";
import BeyondProductLifeCycle46Header from "./Header";
import { ShowHide } from "../components/ShowHideProduct";
import { usePDFShowHide } from "../../../../hooks/usePDFShowHide";
import Flow46Table from "./Table";

const ProdBeyondProductLifeCycle46Components = ({ productId }) => {
  const { t } = useTranslation();
  const [show, setShow] = usePDFShowHide(false, {
    forceShowInPDF: true,
    pdfDelay: 1000,
  });

  return (
    <div className="beyond-product-life-cycle-46-container" id="beyond-product-life-cycle-46-id">
      <BeyondProductLifeCycle46Header productId={productId} show={show} />
      <ShowHide show={show} setShow={setShow} />
      {show && (
        <div className="beyond-product-life-cycle-46-content">
          <Flow46Table productId={productId} />
        </div>
      )}
    </div>
  );
};

export default ProdBeyondProductLifeCycle46Components;

